module.exports = __webpack_public_path__ + "fonts-ebbb6988391cf1e98ca4d42ef27c17a9-icomoon.woff";